export default __webpack_public_path__ + "static/media/Flange.36d3474b.png";